import { AdminOrdersStatusesType } from './shared';

export const adminOrders = (params: { eventId: number; status: AdminOrdersStatusesType }) =>
  `event:${params.eventId},status:${params.status}`;
